// Globals
const tools = document.querySelector('.tools');


// =======================================================
// Search
// =======================================================
// Variables
const body = document.querySelector('body');
const searchpage = document.querySelector('body.search');
const searchTool = tools.querySelector('#js-toolSearch');
const searchPopup = document.querySelector('.search-popup');
const searchModale = document.querySelector('.search-modale');
const searchOverlay = document.querySelector('.search-modale__overlay');
const searchInput = document.querySelector('#searchInput');
const searchClose = document.querySelector('.search-modale__close');

if (searchModale) {
    searchModale.setAttribute('tabindex', -1);
}

if (!searchpage) {
    searchClose.setAttribute('tabindex', -1);
    searchInput.setAttribute('tabindex', -1);
}

// Event click
searchTool.addEventListener('click', function() {
    document.body.classList.add('search-open');
    searchModale.classList.add('showX');
    body.classList.add('js-open-menu');
    searchModale.setAttribute('tabindex', 0);
    document.querySelector('#searchInput').focus()
    searchClose.setAttribute('tabindex', 0);
    searchInput.setAttribute('tabindex', 0);
    if (searchOverlay) {
        searchOverlay.classList.remove('disabled');
    }
})

if (searchModale) {
    const closeSearchModale = () => {
        document.body.classList.remove('search-open');
        searchModale.classList.remove('showX');
        body.classList.remove('js-open-menu');
        searchModale.setAttribute('tabindex', -1);
        if (searchClose) {
            searchClose.setAttribute('tabindex', -1);
        }
        searchInput.setAttribute('tabindex', -1);
        if (searchOverlay) {
            searchOverlay.classList.add('disabled');
        }
    };

    if (searchClose) {
        searchClose.addEventListener('click', closeSearchModale);
    }

    if (searchOverlay) {
        searchOverlay.addEventListener('click', closeSearchModale);
    }

    document.addEventListener('click', (event) => {
        if (!document.body.classList.contains('search-open')) {
            return;
        }

        if (searchModale.contains(event.target)) {
            return;
        }

        if (searchTool && searchTool.contains(event.target)) {
            return;
        }

        closeSearchModale();
    });

    const searchContainer = document.querySelector('#js-searchBarContainer');

    const searchResults = searchContainer.querySelector('#js-searchBarResults');

    if (searchResults.classList.contains('showX')) {
        document.addEventListener("mouseup", function(event) {
            if (!searchContainer.contains(event.target)) {
                searchContainer.classList.remove('search-container-open')
                searchResults.classList.remove('showX')
                searchResults.classList.add('hideX')
                searchResults.classList.add('hide')
            }
        });
    }
}


// =======================================================
// Profils
// =======================================================
// Variable
const profileBtn = tools.querySelector('#js-toolProfile');

// Event click
if (profileBtn) {
    !!profileBtn && profileBtn.addEventListener('click', function() {
        profileBtn.closest('.header').querySelector('.tools-view .profils').classList.toggle('show-list');
    })
}


// =======================================================
// Favorite
// =======================================================
// // Variable
// const favoriteBtn = tools.querySelector('#js-toolFavorite');
// // Event click
// if (favoriteBtn) {
//     !!favoriteBtn && favoriteBtn.addEventListener('click', function() {
//         favoriteBtn.closest('.header').querySelector('.tools-view #divFavorites').classList.toggle('show-list');
//     })
// }
